import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {FlowPageDataProduct, FlowSummary, QuestionFlowCollation} from '../../models/quote.model';
import {QuestionFlowSessionQuery} from '../state/question-flow-session.query';
import {FlowPlayerService} from '../../services/flow-player.service';
import {QuestionQuery} from '../state/question.query';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {Alert} from '../../utilities';
import { UserStore } from 'src/app/modules/authentication/state/user.store';
import { ComponentsService } from '../../services/components-service';
import { SuperflowStore } from '../state/superflow.store';
import { StorageService } from '../../services/storage.service';

declare var $: any;

@Component({
    selector: 'app-question-quote-loader',
    templateUrl: './question-quote-loader.component.html',
    styleUrls: ['./question-quote-loader.component.scss'],
    standalone: false
})
export class QuestionQuoteLoaderComponent implements OnInit, OnChanges, OnDestroy {

  @Input() question: Question;
  @Output() questionAnswer = new EventEmitter<any>();
  @Output() submitResponse = new EventEmitter<any>();
  @Output() showEditModal = new EventEmitter<any>();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSummaryDataChanged = new EventEmitter<any>();

  collations: QuestionFlowCollation[] = [];
  summaryCollations: QuestionFlowCollation[] = [];
  product: FlowPageDataProduct;
  summary = new FlowSummary();
  sessionDetails: any;
  selectedItem: any;
  classes: QuestionFlowCollation[] = [];
  classItems: any[] = [];
  isSavingData = false;
  parameter: any;
  summaryDataSubscription: Subscription;
  recommendation: any;
  user: any;
  window: any['dataLayer'] = window['dataLayer'] || [];
  selectedRecommendation: any
  index0: any;
  constructor(
    public questionService: GlobalQuestionService,
    private flowPlayer: FlowPlayerService,
    private ref: ChangeDetectorRef,
    private router: Router,
    private userStore: UserStore,
    private QuestionQuery: QuestionQuery,
    private superflowStore: SuperflowStore,
    private componentsService: ComponentsService,
    private storageService: StorageService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery) {
    this.sessionDetails = this.questionFlowSessionQuery.getValue();
  }


  ngOnInit(): void {
    this.user = this.userStore.getValue();
    try {
      this.parameter = JSON.parse(this.question.parameter);
    } catch (e) { }

    //this.getPageData();
  }
  ngAfterViewInit(): void {
    // get demoLoadingDelay from query string for testing
    const urlParams: URLSearchParams = new URLSearchParams(window.location.search);
    const demoLoadingDelay: number = parseInt(urlParams.get('demoLoadingDelay') || '60000');

    // adjust as necessary
    const numCards: number = 20;
    const animationDuration: number = 5000;
    const successMsg: string = 'All set!';

    // set custom css variables on loadingCardsEl with Type Safety
    const loadingCardsEl = document.getElementById('loading-cards') as HTMLElement;
    if (loadingCardsEl) {
      loadingCardsEl.style.setProperty('--num-cards', `${numCards}`);
      loadingCardsEl.style.setProperty('--animation-duration', `${animationDuration}ms`);
    }

    // detect when animation begins on first card
    const loadingCardsFirst = document.querySelector('.loading-cards__card:first-child') as HTMLElement;
    if (loadingCardsFirst) {
      loadingCardsFirst.addEventListener('animationstart', () => {
        startCardTimer();
      }, { once: true }); // Ensure it only fires once
    }

    const startCardTimer = (): void => {
      const timestampBeforeLoad: number = new Date().getTime();

      // play the lottie of the first card
      const firstCard = loadingCardsEl?.querySelector('.loading-cards__card:first-child') as HTMLElement;
      const firstLottiePlayer = firstCard?.querySelector('lottie-player') as any;
      if (firstLottiePlayer && typeof firstLottiePlayer.play === 'function') {
        firstLottiePlayer.play();
      }

      // only play the lottie when the card becomes active
      const cardInterval = setInterval(() => {
        const currentCardIndex: number = Math.floor((new Date().getTime() - timestampBeforeLoad) / animationDuration);

        if (currentCardIndex < numCards) {
          const loadingCards: NodeListOf<Element> = loadingCardsEl.querySelectorAll('.loading-cards__card');
          const currentCard = loadingCards[currentCardIndex] as HTMLElement;

          if (!currentCard) {
            clearInterval(cardInterval);
            return;
          }

          const lottiePlayer = currentCard.querySelector('lottie-player') as any;
          if (lottiePlayer && typeof lottiePlayer.play === 'function') {
            lottiePlayer.play();
          }
        } else {
          clearInterval(cardInterval);
        }
      }, animationDuration);
      //this.sessionDetails.session_id
      // --- REAL API CALL REPLACING SIMULATED PROMISE ---
      // Fetch moved to the shared service method so the quote screen can reuse it as a fallback.
      this.questionService.getQuotePageData('quote_loader', this.sessionDetails.session_id, this.sessionDetails.category_id, this.sessionDetails.group_id, this.user?.person_id ? this.user.person_id : '0')
        .subscribe({
          next: (result: any) => {
            console.log('getQuotePageData', result);
            // Same check as quote-pick-cover: a session that is already a policy comes back as a notice instead of
            // page data. Show it in place of the cards, and drop any payload cached before the conversion so the
            // quote screen cannot lay it out.
            this.index0 = this.questionService.getIndex0(result);
            if (this.index0) {
              clearInterval(cardInterval);
              this.storageService.remove('quotePageData', 'flow');
              return;
            }
            if (result && result.length > 0) {
              // This stores the entire structure shown in your image
              this.storageService.setJson('quotePageData', result, 'flow');
            }
            // --- INLINE SHORT-CIRCUIT LOGIC ---
            const timestampAfterLoad: number = new Date().getTime();
            const loadedTime: number = timestampAfterLoad - timestampBeforeLoad;

            const lastCardTextEl = document.getElementById('last-card-text');
            if (lastCardTextEl) {
              lastCardTextEl.textContent = successMsg;
            }

            const currentCardIndex: number = Math.floor(loadedTime / animationDuration);
            let showLoadedStateDelay: number = 0;

            if (currentCardIndex < numCards - 1) {
              const timeToNextCard: number = animationDuration - (loadedTime % animationDuration);
              const loadingCardsFinal = document.querySelector('.loading-cards__card:last-child') as HTMLElement;

              if (loadingCardsFinal) {
                loadingCardsFinal.style.animationDelay = `${loadedTime + timeToNextCard}ms`;
              }

              const loadingCards: NodeListOf<Element> = document.querySelectorAll('.loading-cards__card');
              loadingCards.forEach((card: Element, index: number) => {
                if (index > currentCardIndex && index !== loadingCards.length - 1) {
                  card.remove();
                }
              });

              showLoadedStateDelay = timeToNextCard + 700;
            }

            setTimeout(() => {
              if (loadingCardsEl) {
                loadingCardsEl.classList.add('is-loaded');
              }
            }, showLoadedStateDelay);
          },
          error: (err: any) => {
            console.error('API Error:', err);
            clearInterval(cardInterval);
          }
        });
    };

    document.querySelector('body')?.classList.add('page--questions-no-tray');
  }
  ngOnChanges(changes: SimpleChanges): void {

  }

  // getPageData(): void {
  //   if (this.question) {
  //     const parameters = new Map<string, string>();
  //     parameters.set('session_id', '1768213615214');
  //     parameters.set('category_id', '3');
  //     parameters.set('product_group_id', '3');
  //     parameters.set('page', 'quote');
  //     parameters.set('user_updated', this.user?.person_id ? this.user.person_id : '0');

  //     this.questionService.runCommandNew(`getQuotePageData`, parameters, true)
  //       .subscribe((result) => {
  //         //console.log('getQuotePageData', result);
  //         if (result && result.length > 0) {
  //           // This stores the entire structure shown in your image
  //           sessionStorage.setItem('quotePageData', JSON.stringify(result));
  //         }
  //       });
  //   }
  // }

  gotToNext(): void {
    var a = 'go to quote screen';   
    
    try { a = this.parameter[1]?.value } catch (e) { a = 'go to quote screen' };
    if (!a){ a = 'go to quote screen'; }
    this.question.answer = a; 
    console.log(this.question);
    //this.questionService.saveAnswerOnly(this.question).subscribe();
    this.questionAnswer.emit(this.question);
    this.submitResponse.next(undefined);
  }
 
  ngOnDestroy(): void {

  }
}
